import React, { ButtonHTMLAttributes, ReactNode } from "react";
import "../../Style/Button.css";

type ButtonProps = {
  children?: ReactNode;
  onClick?: () => void;
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  variant?: "primary" | "secondary" | "outline";
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
  loading?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  className?: string;
};

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  iconLeft,
  iconRight,
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`button ${variant} ${size} ${className}`}
    >
      {loading ? (
        <svg
          className="spinner"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      ) : (
        <span className="button-icon">
          {iconLeft && (
            <span style={{ marginRight: "0.5rem" }}>{iconLeft}</span>
          )}
          {children}
          {iconRight && (
            <span style={{ marginLeft: "0.5rem" }}>{iconRight}</span>
          )}
        </span>
      )}
    </button>
  );
};

export default Button;
